import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl, vaccancy_url, experiance_url } from "../../Service/service";
import { deleteData, getData, postData } from "../../Service/ApiMethod";
// import AddDropdownPopup from "../../common/AddDropdownPopup";
import ConfirmationPopup from "../../common/ConfirmationPopup";
import NoVaccancy from "../../common/NoVaccancy";
import { t } from "i18next";
// import ReactPaginate from 'react-paginate';
// import { Modal } from "react-bootstrap";
import { lang } from "../../lang";

const VaccsncyBox = (props) => {
  const { id } = useParams();
  console.log("iddd", id);
  const [ln,setLn] = useState('en')
  const [vaccancy, setVaccancy] = useState();
  const [searchKey, setSearchKey] = useState(props?.searchVal)
  const [isErr, setIsErr] = useState();
  const [experience, setExperience] = useState([]);
  const [vacancyId, setVaccancyId] = useState();
  // console.log("vacancy>>>>>>>>", vacancyId);
  const [deletePopup, setDeletePopup] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [iindex, setIindex] = useState();
  const [userId, setUserId] = useState();
  const [vaccancies, setvaccancies] = useState(props?.vaccancies)
  // const vaccanciess = useRef(props?.vaccancies)

  // const vaccancies = props?.vaccancies
  const errorMessage = props?.isErrMessage
  const currentPg = useRef(1)
  const Totalpg = useRef(1)
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  const getVacancyData = () => {
    getData(vaccancy_url + "?pgNo=" + currentPg.current + "&keyword=" + searchKey)
      .then(res => res.json())
      .then(data => {
        console.log('vaccancies', data.data)
        setvaccancies(data.data.vacancy)
        Totalpg.current = data.data.total_pages
        // setVacancies(data.data.vacancy?.filter((item) => (item?.title !== 'Default')))
        // setBackupVacancyData(data.data.vacancy?.filter((item) => (item?.title !== 'Default')))
      })
      .catch((err) => {
        console.log('err', err)
        // setIsErr(err)
      })
  }




  console.log('props vaccancies', props?.vaccancies,)



  console.log('userid', userId)
  // const handleVaccancy = () => {
  //   try {
  //     const res = await axios.get(baseUrl + "/recruiter/job_post/");
  //     console.log(res.data.data);
  //     setVaccancy(res.data);
  //   }
  //   catch (err) {
  //     console.log(" code", err.message);
  //   }
  // }
  // }
  const navigate = useNavigate();
  const moveVacancyId = (item) => {
    //setVaccancyId(e.target.id);
    setShowPopup(false)
    navigate(`/applicants/${item?.id}`, { state: { data: item } });
  };
  console.log(vacancyId);
  // console.log(vacancyId)


  const deleteVaccancy = async () => {
    const obj = {
      id: userId
    };
    console.log("fddddddddd",obj);

    fetch("https://api.catzapp.com/recruiter/post_vacancy/",
      {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Content-Length': '<calculated when request is sent>',
          Authorization: 'Bearer ' + localStorage.getItem("catzapp_token"),
        },
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json())
    .then((data) => {
      alert(data.message)
      getVacancyData()})
    setDeletePopup(false)
    setShowPopup(false)
    
  }

  const getExperience = () => {
    getData(experiance_url)
      .then((response) => response.json())
      .then((data) => {
        setExperience(data.data);
      })
      .catch((error) => {
        console.log("Error in categories from Post Form", error);
      });
  };
  console.log(experience[0]);

  const handleEdit = (item) => {
    const id = item?.id
    localStorage.setItem("vaccancy_id", id)
    navigate("/post-vaccancy", { state: { item } })
  }


  useEffect(() => {
    getVacancyData()
    async function fetchData() {
      try {
        const res = await axios.get(baseUrl + vaccancy_url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
          },
        });
        console.log(res.data);
        setVaccancy(res.data.data?.filter((item) => (item?.title !== 'Default')));
      } catch (err) {
        console.log(" code", err);
        setIsErr(err);
      }
    }
    getExperience();
    fetchData();
  }, []);
  // console.log( vaccancy[0].id);

  console.log("in vacancy   State", vaccancy);


  // let Package;
  // let PackageTo;


  const onSearch = () => {

    // let temp = [...backupVacancyData];
    if (searchKey.length > 3) {
      Totalpg.current = 1
      getVacancyData();

      // const newData = temp?.filter((item) => (item?.title?.toLowerCase()?.includes(searchKey?.toLowerCase())))
      // console.log('newData', newData)
      // setVacancies(newData?.filter((item) => (item?.title !== 'Default')))
    } else if (searchKey.length < 3) {
      setSearchKey('')
      Totalpg.current = 1
      getVacancyData();
      console('Please Enter a value')
    } else if (searchKey.length == 0) {
      alert('Please Enter a value')
    }

  }
 



  return (
    <>
    
      {/* {isErr != null ? */}
      <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
        <div
          className="search-container flex-center relative"
        >
          <input
            type="text"
            placeholder={t("Search by vacancy title")}
            className="search-input form-control"
            value={searchKey}
            onChange={(e) => {
              setSearchKey(e.target.value)

            }}
            onKeyDown={e => e.key === 'Enter' ? onSearch(searchKey) : ''}

          />
          <span onClick={() => onSearch(searchKey)} style={{ cursor: 'pointer' }}>
            <img src="./images/search.png" alt="search" className="searchIcon VaccancyBoxVacancy" />
          </span>
        </div>
      
      </div>
      {errorMessage &&
        errorMessage != null ?
        (
          <div className="col-lg-2 col-md-2 col-sm-12">
            <div className="recommended-profile p-2 px-0">
              <div className="row">
                <div className="col-md-3 col-12 px-0 relative flex-center vaccancy-pic-area">
                <div className="category-profile" style={{}}>
                  <img
                    src="./images/err.jpg"
                    alt=""
                    style={{ width: "78px", borderRadius: "50%", height: "78px" }}
                    className="profile-img"
                  />
              </div>
                  <div className="profile-match horizontal-center px-2">
                    <img src="./images/blue-eye.png" className="mr-1" alt="" />
                    <span className="match-score">{t('Error Code')}</span>
                  </div>
                </div>
                <div className="col-md-9 col-12  pr-0 mt-1">
                  <h2 className="card-heding text-danger relative">
                    {/* {isErr.message}l */}
                    {errorMessage?.message}l
                  </h2>
                  <p className="designation mt-2 text-primary">
                    {t('Soory!! We are facing some issues')}.
                  </p>
                  <div className="row mt-1">
                    <div className="col-6 px-0">
                      <p className="card-subHeading">{t('Error Name')}</p>
                      <p className="card-subHeading">{t('Code')}</p>
                      <p className="card-subHeading">{t('Method')}</p>
                    </div>
                    <div className="col-6 pl-0">
                      {/* <p className="profile-info">{isErr?.name}</p> */}
                      <p className="profile-info">{errorMessage?.name}</p>
                      {/* <p className="profile-info">{isErr?.code}</p> */}
                      <p className="profile-info">{errorMessage?.code}</p>
                      {/* <p className="profile-info">{isErr?.config.method}</p> */}
                      <p className="profile-info">{errorMessage?.config?.method}</p>
                    </div>
                    <div className="col-6 px-0">
                      <p className="horizontal-center"></p>
                    </div>
                    <div className="col-6 pl-0">
                      <p className="post-day text-right">{t('Solving it Soon')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        ) : (vaccancies?.length != 0 ? vaccancies ? (
          vaccancies?.length != 0 ?
            (vaccancies || vaccancy)?.map((item, index) => {
              // const salary = Number(item?.compensation_amount);

              // if (salary > 1000) {
              //   Package = Math.floor(salary / 1000) + "k";
              //   PackageTo = Math.floor((salary + 5000) / 1000) + "k";
              // } else {
              //   Package = salary;
              //   PackageTo = salary + 1000;
              // }

              // if (item.compensation_details === "Monthly") {
              //   // item.compensation_details = "M";
              // } else if (item.compensation_details === "Yearly") {
              //   // item.compensation_details = "Y";
              // } else if (item.compensation_details === "Day") {
              //   item.compensation_details = "Daily";
              // } else if (item.compensation_details === "Weekly") {
              //   // item.compensation_details = "W";
              // }
              if (item?.length === 0) {
                return <NoVaccancy />;
              } else {
                return (
                  <div className={props?.cols} key={index} style={{
                    // border:'1px solid black',
                    flex: '1 1 21rem',
                    flexWrap: 'wrap',
                    alignSelf: 'normal',
                    display: 'flex'
                  }}
                    onClick={(e) => {
                      setVaccancyId(e.target.id);
                      console.log(vacancyId);
                      moveVacancyId(item);
                    }}
                  >
                    <div
                      className="recommended-profile p-2"
                      id={item?.id}
                      name="clcikedd"
                      style={{
                        // border:'1px solid blue',
                        alignSelf: 'normal',
                        flexWrap: 'wrap',
                        display: 'flex'
                      }}
                    >
                      <div
                        className="row"
                        style={{
                          // border:'1px solid blue',
                          alignSelf: 'normal',
                          display: 'flex',
                          flexWrap: 'wrap'
                        }}
                      >
                        <div className="col-md-3 col-12 px-0 relative flex-center vaccancy-pic-area"
                          onClick={(e) => {
                            setVaccancyId(e.target.id);
                            console.log(vacancyId);
                            moveVacancyId(item);
                          }}
                          style={{
                            borderRadius: '3px',
                         
                          }}
                        >
                               <div className="category-profile" style={{}}>
                          <img
                            src={item?.job_category_icon || "./images/plumber.png"}
                            alt=""
                            className="profile-img"
                          />
                          </div>
                          <div className="profile-match horizontal-center px-2"

                          >
                            <img
                              src="./images/blue-eye.png"
                              className="mr-1"
                              alt=""
                            />
                            <span className="match-score" style={{ color: 'blue' }}>
                              {item?.no_of_applicants} {item?.no_of_applicants > 1 ? `${t('Applications')}` : `${t('Application')}`}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-9 col-12 pr-0 mt-1"
                          style={{
                            // border:'1px solid purple',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                          }}>
                          <h2 className="card-heding relative"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              // border:'1px solid purple'
                            }}
                          >
                            {item?.title}
                            <img
                              src="./images/pencilBlack.png"
                              alt=""
                              style={{ }}
                              className="addprofile side-icon"
                              key={index}
                              onMouseOver={()=>{
                                setShowPopup(true)
                                setIindex(index)
                                setUserId(item?.id)
                              }}
                              onMouseOut={()=>{
                                setTimeout(()=>{
                                  setShowPopup(false)
                                  setIindex(index)
                                  setUserId(item?.id)
                                },1500)
                              }}
                              id={item?.id}
                              onClick={(e) => {
                                e.stopPropagation()
                                setShowPopup(!showPopup)
                                setIindex(index)
                                setUserId(item?.id)
                              }}
                            />
                            
                            {((iindex == index) && showPopup) &&

                              <div className="imgg-style" style={{}}>


                                <div className="" style={{ width: 'fit-content', cursor: 'pointer', marginBottom: '3px', border: '1px solid black', textAlign: 'center', borderRadius: '2px', backgroundColor: '#e9eff6', fontSize: '16px', padding: '4px' }}
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleEdit(item)

                                  }}>{t('Edit')} </div>


                                <div className="" style={{ border: '1px solid black', textAlign: 'center', borderRadius: '2px', cursor: 'pointer', backgroundColor: '#e9eff6', fontSize: '16px', padding: '4px' }} onClick={(e) => {
                                  e.stopPropagation()
                                  setDeletePopup(true)
                                  console.log(item,"djjjf",userId);
                                  localStorage.setItem("vaccancy_id", userId)

                                }}>{t('Delete')}</div>
                              </div>
                            }

                            {/* <img
                          src="./images/err.jpg"
                          alt=""
                          style={{ height: "16px" }}
                          className="addprofile"
                          id={item.id}
                          onClick={(e) =>{ setDeletePopup(true); localStorage.setItem("vaccancy_id", e.target.id)}}
                        /> */}
                          </h2>
                          <p className="designation mt-2" >
                            {item?.urgent_vacancy ? (
                              <span>{t('Required')} {item?.job_category_name} {t('Immediately')}</span>
                            ) : 
                            (
                              <span>{lang && Object.keys(lang).length > 0 ? lang[ln]?.new["No Required Immediately"]:""}</span>
                            )
                            }
                          </p>
                          <div className="row mt-1"
                            style={{
                              display: 'flex',
                              alignContent: 'space-between',
                              // border:'1px solid blue',
                              height: 'unset'
                            }}>
                            {/* <div className="col-6 px-0">
                          <p className="card-subHeading">Total Experience</p>
                          <p className="card-subHeading">Work Location</p>
                          <p className="card-subHeading">Package</p>
                        </div>
                        <div className="col-6 px-0">
                          <p className="profile-info">
                            {item?.experience} {(item?.experience)>1 ? 'Years': 'Year'}
                          </p>
                          <p className="profile-info">{(item?.work_location)}</p>
                          <p className="profile-info">
                            {" "}
                            {item?.currency} {item?.compensation_amount} {item?.compensation_details}
                          </p>
                        </div> */}
                            {/* ------------------------new columns------------------------- */}
                            <div className="col-12 px-0">
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                // border:'1px solid black'
                              }} >
                                <p className="card-subHeading">{t('Total Experience')}</p>
                                <p className="profile-info">
                                  {item?.experience} {(item?.experience) > 1 ? `${lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Years']:""}` : `${lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Year']:""}`}
                                </p>
                              </div>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                // border:'1px solid black'
                              }} >
                                <p className="card-subHeading worklocation">{t('Work Location')}</p>
                                <p className="profile-info">
                                  {/* {(item?.work_location)} */}
                                  {(item?.work_location?.length > 15) ? item?.work_location.slice(0, 15) + '...' : item?.work_location}
                                </p>
                              </div>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                // border:'1px solid black'
                              }} >
                                <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.MyListsScreen['Package']:""}</p>
                                <p className="profile-info">
                                  {item?.currency} {item?.compensation_amount} {lang && Object.keys(lang).length > 0 ? lang[ln]?.new[item?.compensation_details]:""}
                                </p>
                              </div>
                            </div>
                            {/* ------------------------new columns end------------------------- */}

                            {/* <div className="col-6 px-0">
                          <p className="horizontal-center">
                            <img
                      src="./images/match-badge.png"
                      className="img-size18"
                      alt=""
                    />
                    <span className="ms-1 match-profile">99% Match</span>
                          </p>
                        </div> */}

                            <div style={{
                              width: '100%', padding: '0', textAlign: 'right',
                              // border:'1px solid red'
                            }}>
                              <p className="post-day text-right"
                                style={{
                                  width: '100%',
                                  // border:'1px solid green',
                                  textAlign: 'end',
                                  paddingBottom: '0'
                                }} >
                                {t('Posted')} {new Date(item?.posted_on).toDateString()} {t('ago')}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <hr style={{background:'black', height:'1px', fontSize:'5px', fontWeight:'bold'}} /> */}
                  </div>
                );
              }
            }) : <div style={{ width: '100%', height: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {props?.loader == true ? null : <h3 className="novacancy">{t('No Vacancy Found')}</h3>}
            </div>
        ) :
          <div style={{ width: '100%', height: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {props?.loader == true ? null : <h3 className="novacancy">{t('No Vacancy Found')}</h3>}
          </div>
          : <div style={{ width: '100%', height: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {props?.loader == true ? null : <h3 className="novacancy">{t('No Vacancy Found')}</h3>}
          </div>)
      }
      <div style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        marginBottom: 10
      }}>
        <div>
          <p style={{ marginBottom: 0, paddingRight: 5, cursor: "pointer" }} onClick={() => {
            if (currentPg.current > 1) {
              currentPg.current = currentPg.current - 1
              console.log("yo");
              getVacancyData()
            } else {
              console.log("no more data found");
            }
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["previous"]:""}</p> 
        </div>
        <input placeholder='Pg. no.' type="text"
          disabled={true}
          style={{
            textAlign: "center",
            width: 60,
            padding: 10,
            borderColor: "#f2edf3",
            backgroundColor: "#f2edf3",
            borderRadius: 10,
            borderWidth: 0
          }} value={currentPg.current + "/" + Totalpg.current} />
        <div>
          <p style={{ marginBottom: 0, paddingLeft: 5, cursor: "pointer" }} onClick={() => {
            if (currentPg.current < Totalpg.current) {
              currentPg.current = currentPg.current + 1
              console.log("yono");
              getVacancyData()
            } else {
              console.log("no more data found");
            }
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Next"]:""}</p>
        </div>
      </div>
      {deletePopup ? (
        <ConfirmationPopup
          title="Are You Sure!"
          leg={ln}
          subTitle="You want to delete this Vaccancy?"
          handleNo={(e) => setDeletePopup(false)}
          handleYes={() => deleteVaccancy()}
        />
      ) : null}
      <>
        <div>

        </div>
        { }
      </>
      {/* <div className="col-lg-4 col-md-6 col-sm-12">
      <Link to="/applicants" className=" link ">
        <div className="recommended-profile p-2 px-0">
          <div className="row">
            <div className="col-4 px-0 relative flex-center vaccancy-pic-area">
              <img src="./images/plumber.png" alt="" className="vaccancy-pic" />
              <div className="profile-match horizontal-center px-2">
                <img src="./images/blue-eye.png" className="mr-1" alt="" />
                <span className="match-score">25 Applications</span>
              </div>
            </div>
            <div className="col-8 pr-0 mt-1">
              <h2 className="card-heding relative">
                Plumber
                <img
                  src="./images/pencilBlack.png"
                  alt=""
                  className="addprofile"
                />
              </h2>
              <p className="designation mt-2">Required Plumbers Immediately</p>
              <div className="row mt-1">
                <div className="col-6 px-0">
                  <p className="card-subHeading">Total Experience</p>
                  <p className="card-subHeading">Work Location</p>
                  <p className="card-subHeading">Package</p>
                </div>
                <div className="col-6 pl-0">
                  <p className="profile-info">1.5 Years </p>
                  <p className="profile-info">Finland</p>
                  <p className="profile-info"> $700-$1000/m </p>
                </div>
                <div className="col-6 px-0">
                  <p className="horizontal-center">
                    <img
                      src="./images/match-badge.png"
                      className="img-size18"
                      alt=""
                    />
                    <span className="ms-1 match-profile">99% Match</span>
                  </p>
                </div>
                <div className="col-6 pl-0">
                  <p className="post-day text-right">Posted 1 day ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
      <hr />
    </div>

    <div className="col-lg-4 col-md-6 col-sm-12">
      <Link to="/applicants" className=" link ">
        <div className="recommended-profile p-2 px-0">
          <div className="row">
            <div className="col-4 px-0 relative flex-center vaccancy-pic-area">
              <img src="./images/plumber.png" alt="" className="vaccancy-pic" />
              <div className="profile-match horizontal-center px-2">
                <img src="./images/blue-eye.png" className="mr-1" alt="" />
                <span className="match-score">25 Applications</span>
              </div>
            </div>
            <div className="col-8 pr-0 mt-1">
              <h2 className="card-heding relative">
                Plumber
                <img
                  src="./images/pencilBlack.png"
                  alt=""
                  className="addprofile"
                />
              </h2>
              <p className="designation mt-2">Required Plumbers Immediately</p>
              <div className="row mt-1">
                <div className="col-6 px-0">
                  <p className="card-subHeading">Total Experience</p>
                  <p className="card-subHeading">Work Location</p>
                  <p className="card-subHeading">Package</p>
                </div>
                <div className="col-6 pl-0">
                  <p className="profile-info">1.5 Years </p>
                  <p className="profile-info">Finland</p>
                  <p className="profile-info"> $700-$1000/m </p>
                </div>
                <div className="col-6 px-0">
                  <p className="horizontal-center">
                    <img
                      src="./images/match-badge.png"
                      className="img-size18"
                      alt=""
                    />
                    <span className="ms-1 match-profile">99% Match</span>
                  </p>
                </div>
                <div className="col-6 pl-0">
                  <p className="post-day text-right">Posted 1 day ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
      <hr />
    </div> */}

      {/* <div className="col-lg-4 col-md-6 col-sm-12">
      <Link to="/applicants" className=" link ">
        <div className="recommended-profile p-2 px-0">
          <div className="row">
            <div className="col-4 px-0 relative flex-center vaccancy-pic-area">
              <img src="./images/plumber.png" alt="" className="vaccancy-pic" />
              <div className="profile-match horizontal-center px-2">
                <img src="./images/blue-eye.png" className="mr-1" alt="" />
                <span className="match-score">25 Applications</span>
              </div>
            </div>
            <div className="col-8 pr-0 mt-1">
              <h2 className="card-heding relative">
                Plumber
                <img
                  src="./images/pencilBlack.png"
                  alt=""
                  className="addprofile"
                />
              </h2>
              <p className="designation mt-2">Required Plumbers Immediately</p>
              <div className="row mt-1">
                <div className="col-6 px-0">
                  <p className="card-subHeading">Total Experience</p>
                  <p className="card-subHeading">Work Location</p>
                  <p className="card-subHeading">Package</p>
                </div>
                <div className="col-6 pl-0">
                  <p className="profile-info">1.5 Years </p>
                  <p className="profile-info">Finland</p>
                  <p className="profile-info"> $700-$1000/m </p>
                </div>
                <div className="col-6 px-0">
                  <p className="horizontal-center">
                    <img
                      src="./images/match-badge.png"
                      className="img-size18"
                      alt=""
                    />
                    <span className="ms-1 match-profile">99% Match</span>
                  </p>
                </div>
                <div className="col-6 pl-0">
                  <p className="post-day text-right">Posted 1 day ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
      <hr />
    </div> */}
   
    </>
  );
};

export default VaccsncyBox;
